import useLocationHook from 'hooks/useLocationHook';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Text } from 'styles';

export function Aside({ setRef, nav }) {
  const [currentNav, setCurrentNav] = useState();
  const [activeKey, setActiveKey] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const currentLastUrl = useLocationHook();

  const moveScroll = (item, index) => {
    if (location.pathname.includes('community')) {
      navigate(item.path);
    } else {
      setRef.current[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  // 경로 일치 여부: 정확히 같거나 하위 경로 (/community/board/6 이 /community/board/66 에 걸리지 않도록 경계 체크)
  const isCurrent = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  useEffect(() => {
    setCurrentNav(nav.filter((el) => el.path.includes(window.location.pathname.split('/')[1]))[0]);
  }, [nav]);

  return (
    currentNav && (
      <Container $index={currentNav.sub.length}>
        <ul>
          {currentNav.sub.map((item, index) => (
            <ListItem
              key={`item_${index}`}
              onClick={() => {
                setActiveKey(index + 1);
                moveScroll(item, index);
              }}
              // $active={item.path.includes(currentLastUrl) || setRef.current[index]}
              $active={
                currentNav.path.includes('company')
                  ? Number(item.path.split('/')[2]) === activeKey
                  : isCurrent(item.path)
              }
            >
              <Text
                $type="b5"
                $tType="b7"
                $tLineHeight="1"
                $textAlign="center"
                $color={(isCurrent(item.path) && 'primary') || 'secondary'}
                $fontWeight={(isCurrent(item.path) && 700) || 500}
              >
                {item.name}
              </Text>
            </ListItem>
          ))}
        </ul>
      </Container>
    )
  );
}

const ListItem = styled.li`
  position: relative;
  overflow: hidden;

  &:last-of-type {
    border-radius: 0 0 16px 0;
  }

  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    width: 0;
    left: 0;
    bottom: 0;
    height: 2px;
    transition: all linear 250ms;
    background-color: ${({ theme }) => theme.colors.primary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 2px;
    background-color: ${({ $active, theme }) => ($active && `${theme.colors.primary}`) || `${theme.colors.fill03}`};
  }

  &:hover {
    &::before {
      width: 100%;
    }
  }
`;

const Container = styled.div`
  position: sticky;
  align-self: flex-start;
  z-index: 5;
  top: 208px;
  border-radius: 16px 0 16px 0;
  box-shadow: ${({ theme }) => theme.colors.boxShadow};

  & > ul > li {
    cursor: pointer;
    padding: 14px 24px;
    min-width: 272px;
    width: 100%;
  }

  & > ul > li:nth-last-child(1) {
    border-bottom: 0;
  }

  @media ${({ theme }) => theme.device.tablet} {
    display: flex;
    width: 100%;
    top: 105px;
    box-shadow: none;
    border-radius: unset;

    & > ul {
      display: flex;
      width: 100%;
    }

    & > ul > li {
      padding: 22px 0;
      min-width: unset;
    }

    & > ul > li:nth-last-child(1) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.fill03};
    }
  }
`;
